import "core-js/modules/es.array.reverse.js";
var _class, _ArcGisFeatureServerStratum;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { computed, makeObservable } from "mobx";
import proj4 from "proj4";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import Proj4Definitions from "../../../Map/Vector/Proj4Definitions";
import { hasUnsupportedStylesForProtomaps } from "../../../Map/Vector/Protomaps/tableStyleToProtomaps";
import ArcGisFeatureServerCatalogItemTraits from "../../../Traits/TraitsClasses/ArcGisFeatureServerCatalogItemTraits";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import { RectangleTraits } from "../../../Traits/TraitsClasses/MappableTraits";
import TableColorStyleTraits, { EnumColorTraits } from "../../../Traits/TraitsClasses/Table/ColorStyleTraits";
import TableColumnTraits from "../../../Traits/TraitsClasses/Table/ColumnTraits";
import TableOutlineStyleTraits, { BinOutlineSymbolTraits, EnumOutlineSymbolTraits } from "../../../Traits/TraitsClasses/Table/OutlineStyleTraits";
import TablePointSizeStyleTraits from "../../../Traits/TraitsClasses/Table/PointSizeStyleTraits";
import TablePointStyleTraits, { BinPointSymbolTraits, EnumPointSymbolTraits } from "../../../Traits/TraitsClasses/Table/PointStyleTraits";
import TableStyleTraits from "../../../Traits/TraitsClasses/Table/StyleTraits";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import getToken from "../../getToken";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import { esriStyleToTableStyle } from "./esriStyleToTableStyle";

// simple fill style

/** as defined https://developers.arcgis.com/web-map-specification/objects/esriSFS_symbol/ */

// no fill

/** as defined https://developers.arcgis.com/web-map-specification/objects/esriSMS_symbol/ */

/** as defined https://developers.arcgis.com/web-map-specification/objects/esriSLS_symbol/ */

/** as defined https://developers.arcgis.com/web-map-specification/objects/symbol/ */

/**
 * See https://developers.arcgis.com/web-map-specification/objects/uniqueValueRenderer/
 */

// https://developers.arcgis.com/web-map-specification/objects/simpleRenderer/

/** For JSON Schema for FeatureServer Layer response see https://developers.arcgis.com/rest/services-reference/enterprise/layer-feature-service/#json-response-syntax */

const fieldTypeToTableColumn = {
  esriFieldTypeSmallInteger: "scalar",
  esriFieldTypeInteger: "scalar",
  esriFieldTypeSingle: "scalar",
  esriFieldTypeDouble: "scalar",
  esriFieldTypeString: "text",
  esriFieldTypeDate: "time",
  esriFieldTypeOID: "scalar",
  esriFieldTypeGeometry: "hidden",
  esriFieldTypeBlob: "hidden",
  esriFieldTypeRaster: "hidden",
  esriFieldTypeGUID: "hidden",
  esriFieldTypeGlobalID: "hidden",
  esriFieldTypeXML: "hidden",
  esriFieldTypeBigInteger: "scalar"
};
export let ArcGisFeatureServerStratum = (_class = (_ArcGisFeatureServerStratum = class ArcGisFeatureServerStratum extends LoadableStratum(ArcGisFeatureServerCatalogItemTraits) {
  constructor(_item, _featureServer, _token) {
    super();
    this._item = _item;
    this._featureServer = _featureServer;
    this._token = _token;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new ArcGisFeatureServerStratum(newModel, this._featureServer, this._token);
  }
  static async load(item) {
    if (item.url === undefined) {
      return new ArcGisFeatureServerStratum(item, undefined, undefined);
    }
    let token;
    if (isDefined(item.tokenUrl) && isDefined(item.url)) {
      token = await getToken(item.terria, item.tokenUrl, item.url);
    } else if (isDefined(item.token)) {
      token = item.token;
    }
    const metaUrl = buildMetadataUrl(item, token);
    const featureServer = await loadJson(metaUrl);
    return new ArcGisFeatureServerStratum(item, featureServer, token);
  }
  get token() {
    return this._token;
  }
  get shortReport() {
    var _this$_item$readyData;
    // Show notice if reached
    if (((_this$_item$readyData = this._item.readyData) === null || _this$_item$readyData === void 0 ? void 0 : _this$_item$readyData.features) !== undefined && this._item.readyData.features.length >= this._item.maxFeatures) {
      return i18next.t("models.arcGisFeatureServerCatalogItem.reachedMaxFeatureLimit", this._item);
    }
    return undefined;
  }
  get maxScaleDenominator() {
    var _this$_featureServer;
    return (_this$_featureServer = this._featureServer) === null || _this$_featureServer === void 0 ? void 0 : _this$_featureServer.minScale;
  }
  get minScaleDenominator() {
    var _this$_featureServer2;
    return (_this$_featureServer2 = this._featureServer) === null || _this$_featureServer2 === void 0 ? void 0 : _this$_featureServer2.maxScale;
  }
  get name() {
    var _this$_featureServer3;
    if (((_this$_featureServer3 = this._featureServer) === null || _this$_featureServer3 === void 0 ? void 0 : _this$_featureServer3.name) !== undefined && this._featureServer.name.length > 0) {
      return replaceUnderscores(this._featureServer.name);
    }
  }
  get dataCustodian() {
    var _this$_featureServer4, _this$_featureServer5, _this$_featureServer6;
    if ((_this$_featureServer4 = this._featureServer) !== null && _this$_featureServer4 !== void 0 && _this$_featureServer4.documentInfo && (_this$_featureServer5 = this._featureServer) !== null && _this$_featureServer5 !== void 0 && _this$_featureServer5.documentInfo.Author && ((_this$_featureServer6 = this._featureServer) === null || _this$_featureServer6 === void 0 ? void 0 : _this$_featureServer6.documentInfo.Author.length) > 0) {
      return this._featureServer.documentInfo.Author;
    }
  }
  get rectangle() {
    var _this$_featureServer7, _extent$spatialRefere, _extent$spatialRefere2, _extent$spatialRefere3;
    const extent = (_this$_featureServer7 = this._featureServer) === null || _this$_featureServer7 === void 0 ? void 0 : _this$_featureServer7.extent;
    const wkidCode = (_extent$spatialRefere = extent === null || extent === void 0 || (_extent$spatialRefere2 = extent.spatialReference) === null || _extent$spatialRefere2 === void 0 ? void 0 : _extent$spatialRefere2.latestWkid) !== null && _extent$spatialRefere !== void 0 ? _extent$spatialRefere : extent === null || extent === void 0 || (_extent$spatialRefere3 = extent.spatialReference) === null || _extent$spatialRefere3 === void 0 ? void 0 : _extent$spatialRefere3.wkid;
    if (isDefined(extent) && isDefined(wkidCode)) {
      const wkid = "EPSG:" + wkidCode;
      if (!isDefined(Proj4Definitions[wkid])) {
        return undefined;
      }
      const source = Proj4Definitions[wkid];
      const dest = "EPSG:4326";
      let p = proj4(source, dest, [extent.xmin, extent.ymin]);
      const west = p[0];
      const south = p[1];
      p = proj4(source, dest, [extent.xmax, extent.ymax]);
      const east = p[0];
      const north = p[1];
      const rectangle = {
        west: west,
        south: south,
        east: east,
        north: north
      };
      return createStratumInstance(RectangleTraits, rectangle);
    }
    return undefined;
  }
  get info() {
    var _this$_featureServer8, _this$_featureServer9;
    return [createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisMapServerCatalogItem.dataDescription"),
      content: (_this$_featureServer8 = this._featureServer) === null || _this$_featureServer8 === void 0 ? void 0 : _this$_featureServer8.description
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisMapServerCatalogItem.copyrightText"),
      content: (_this$_featureServer9 = this._featureServer) === null || _this$_featureServer9 === void 0 ? void 0 : _this$_featureServer9.copyrightText
    })];
  }
  get supportsPagination() {
    if (this._featureServer === undefined || this._featureServer.advancedQueryCapabilities === undefined) {
      return false;
    }
    return !!this._featureServer.advancedQueryCapabilities.supportsPagination;
  }
  get activeStyle() {
    return "ESRI";
  }
  get styles() {
    var _this$_featureServer0;
    const renderer = (_this$_featureServer0 = this._featureServer) === null || _this$_featureServer0 === void 0 || (_this$_featureServer0 = _this$_featureServer0.drawingInfo) === null || _this$_featureServer0 === void 0 ? void 0 : _this$_featureServer0.renderer;
    if (!renderer) return [];
    const rendererType = renderer.type;
    if (rendererType === "simple") {
      var _simpleRenderer$visua, _symbolStyle$color;
      const simpleRenderer = renderer;
      const symbol = simpleRenderer.symbol;
      if ((_simpleRenderer$visua = simpleRenderer.visualVariables) !== null && _simpleRenderer$visua !== void 0 && _simpleRenderer$visua.length) {
        console.warn("WARNING: Terria does not support visual variables in ArcGisFeatureService SimpleRenderers");
      }
      if (!symbol) return [];
      const symbolStyle = esriStyleToTableStyle(symbol, simpleRenderer.label);
      return [createStratumInstance(TableStyleTraits, {
        id: "ESRI",
        hidden: false,
        color: createStratumInstance(TableColorStyleTraits, {
          nullColor: (_symbolStyle$color = symbolStyle.color) !== null && _symbolStyle$color !== void 0 ? _symbolStyle$color : "#ffffff"
        }),
        pointSize: symbolStyle.pointSize,
        point: createStratumInstance(TablePointStyleTraits, {
          null: symbolStyle.point
        }),
        outline: createStratumInstance(TableOutlineStyleTraits, {
          null: symbolStyle.outline
        })
      })];
    } else if (rendererType === "uniqueValue") {
      var _uniqueValueRenderer$;
      const uniqueValueRenderer = renderer;
      const symbolStyles = uniqueValueRenderer.uniqueValueInfos.map(v => {
        return esriStyleToTableStyle(v.symbol, v.label);
      });
      const defaultSymbolStyle = esriStyleToTableStyle(uniqueValueRenderer.defaultSymbol, undefined);

      // Only include color if there are any styles which aren't esriPMS
      const includeColor = !!uniqueValueRenderer.uniqueValueInfos.find(u => {
        var _u$symbol;
        return ((_u$symbol = u.symbol) === null || _u$symbol === void 0 ? void 0 : _u$symbol.type) !== "esriPMS";
      });
      if (uniqueValueRenderer.field2 || uniqueValueRenderer.field3) {
        console.warn("WARNING: Terria only supports ArcGisFeatureService UniqueValueRenderers with a single field (`field1`), not multiple fields (`field2` or `field3`)");
      }
      if ((_uniqueValueRenderer$ = uniqueValueRenderer.visualVariables) !== null && _uniqueValueRenderer$ !== void 0 && _uniqueValueRenderer$.length) {
        console.warn("WARNING: Terria does not support visual variables in ArcGisFeatureService UniqueValueRenderers");
      }
      if (uniqueValueRenderer.valueExpression) {
        console.warn("WARNING: Terria does not support value expressions in ArcGisFeatureService UniqueValueRenderers");
      }
      if (!uniqueValueRenderer.field1) {
        console.warn("WARNING: Terria does not support empty field1 in UniqueValueRenderers, using default style");
        return [];
      }
      return [createStratumInstance(TableStyleTraits, {
        id: "ESRI",
        hidden: false,
        color: includeColor ? createStratumInstance(TableColorStyleTraits, {
          colorColumn: uniqueValueRenderer.field1,
          mapType: "enum",
          enumColors: uniqueValueRenderer.uniqueValueInfos.map((v, i) => {
            var _symbolStyles$i$color;
            return createStratumInstance(EnumColorTraits, {
              value: v.value,
              color: (_symbolStyles$i$color = symbolStyles[i].color) !== null && _symbolStyles$i$color !== void 0 ? _symbolStyles$i$color : "#ffffff"
            });
          }),
          nullColor: defaultSymbolStyle.color
        }) : createStratumInstance(TableColorStyleTraits, {
          nullColor: "#FFFFFF"
        }),
        pointSize: createStratumInstance(TablePointSizeStyleTraits, {}),
        point: createStratumInstance(TablePointStyleTraits, {
          mapType: "enum",
          column: uniqueValueRenderer.field1,
          enum: uniqueValueRenderer.uniqueValueInfos.map((v, i) => createStratumInstance(EnumPointSymbolTraits, _objectSpread({
            value: v.value
          }, symbolStyles[i].point))),
          null: defaultSymbolStyle.point
        }),
        outline: createStratumInstance(TableOutlineStyleTraits, {
          mapType: "enum",
          column: uniqueValueRenderer.field1,
          enum: uniqueValueRenderer.uniqueValueInfos.map((v, i) => createStratumInstance(EnumOutlineSymbolTraits, _objectSpread({
            value: v.value
          }, symbolStyles[i].outline))),
          null: defaultSymbolStyle.outline
        })
      })];
    } else if (rendererType === "classBreaks") {
      var _classBreaksRenderer$;
      const classBreaksRenderer = renderer;
      if ((_classBreaksRenderer$ = classBreaksRenderer.visualVariables) !== null && _classBreaksRenderer$ !== void 0 && _classBreaksRenderer$.length) {
        console.warn("WARNING: Terria does not support visual variables in ArcGisFeatureService ClassBreakRenderers");
      }
      if (classBreaksRenderer.valueExpression) {
        console.warn("WARNING: Terria does not support value expressions in ArcGisFeatureService ClassBreakRenderers");
      }
      const symbolStyles = classBreaksRenderer.classBreakInfos.map(c => esriStyleToTableStyle(c.symbol, c.label));
      const defaultSymbolStyle = esriStyleToTableStyle(classBreaksRenderer.defaultSymbol, undefined);

      // Only include color if there are any styles which aren't esriPMS
      const includeColor = !!classBreaksRenderer.classBreakInfos.find(u => {
        var _u$symbol2;
        return ((_u$symbol2 = u.symbol) === null || _u$symbol2 === void 0 ? void 0 : _u$symbol2.type) !== "esriPMS";
      });
      return [createStratumInstance(TableStyleTraits, {
        id: "ESRI",
        hidden: false,
        color: includeColor ? createStratumInstance(TableColorStyleTraits, {
          mapType: "bin",
          colorColumn: classBreaksRenderer.field,
          binColors: symbolStyles.map(s => {
            var _s$color;
            return (_s$color = s.color) !== null && _s$color !== void 0 ? _s$color : "";
          }),
          binMaximums: classBreaksRenderer.classBreakInfos.map(c => c.classMaxValue),
          nullColor: defaultSymbolStyle.color
        }) : createStratumInstance(TableColorStyleTraits, {
          nullColor: "#FFFFFF"
        }),
        pointSize: createStratumInstance(TablePointSizeStyleTraits, {}),
        point: createStratumInstance(TablePointStyleTraits, {
          mapType: "bin",
          column: classBreaksRenderer.field,
          bin: classBreaksRenderer.classBreakInfos.map((c, i) => createStratumInstance(BinPointSymbolTraits, _objectSpread({
            maxValue: c.classMaxValue
          }, symbolStyles[i].point))),
          null: defaultSymbolStyle.point
        }),
        outline: createStratumInstance(TableOutlineStyleTraits, {
          mapType: "bin",
          column: classBreaksRenderer.field,
          bin: classBreaksRenderer.classBreakInfos.map((c, i) => createStratumInstance(BinOutlineSymbolTraits, _objectSpread({
            maxValue: c.classMaxValue
          }, symbolStyles[i].outline))),
          null: defaultSymbolStyle.outline
        })
      })];
    } else {
      console.warn("WARNING: Terria does not support ArcGisFeatureService renderers of type ".concat(rendererType));
    }
  }

  // Map ESRI fields to Terria columns. This just sets the name, title and type of the column
  get columns() {
    var _this$_featureServer$, _this$_featureServer1;
    return (_this$_featureServer$ = (_this$_featureServer1 = this._featureServer) === null || _this$_featureServer1 === void 0 || (_this$_featureServer1 = _this$_featureServer1.fields) === null || _this$_featureServer1 === void 0 ? void 0 : _this$_featureServer1.filter(field => {
      if (!fieldTypeToTableColumn[field.type]) {
        console.warn("WARNING: Terria does not support ESRI field type ".concat(field.type));
        return false;
      }
      return true;
    }).map(field => {
      var _fieldTypeToTableColu;
      return createStratumInstance(TableColumnTraits, {
        name: field.name,
        title: field.alias,
        type: (_fieldTypeToTableColu = fieldTypeToTableColumn[field.type]) === null || _fieldTypeToTableColu === void 0 ? void 0 : _fieldTypeToTableColu.toString()
      });
    })) !== null && _this$_featureServer$ !== void 0 ? _this$_featureServer$ : [];
  }
  get featuresPerRequest() {
    var _this$_featureServer10;
    return (_this$_featureServer10 = this._featureServer) === null || _this$_featureServer10 === void 0 ? void 0 : _this$_featureServer10.maxRecordCount;
  }
  get featuresPerTileRequest() {
    var _this$_featureServer11;
    return (_this$_featureServer11 = this._featureServer) === null || _this$_featureServer11 === void 0 ? void 0 : _this$_featureServer11.tileMaxRecordCount;
  }
  get maxRecordCountFactor() {
    var _this$_featureServer12;
    return (_this$_featureServer12 = this._featureServer) === null || _this$_featureServer12 === void 0 ? void 0 : _this$_featureServer12.maxRecordCountFactor;
  }
  get supportsQuantization() {
    var _this$_featureServer13;
    return !!((_this$_featureServer13 = this._featureServer) !== null && _this$_featureServer13 !== void 0 && _this$_featureServer13.supportsCoordinatesQuantization);
  }

  /** Enable tileRequests by default if supported and no unsupported point/label styles are used */
  get tileRequests() {
    var _this$_featureServer14, _this$_featureServer15;
    if (this._item.forceCesiumPrimitives) return false;
    const supportsPbfTiles = ((_this$_featureServer14 = this._featureServer) === null || _this$_featureServer14 === void 0 ? void 0 : _this$_featureServer14.supportsTilesAndBasicQueriesMode) && typeof ((_this$_featureServer15 = this._featureServer) === null || _this$_featureServer15 === void 0 ? void 0 : _this$_featureServer15.supportedQueryFormats) === "string" && this._featureServer.supportedQueryFormats.toLowerCase().includes("pbf");
    if (supportsPbfTiles) {
      return !hasUnsupportedStylesForProtomaps(this._item);
    }
    return undefined;
  }
  get objectIdField() {
    var _this$_featureServer16;
    return (_this$_featureServer16 = this._featureServer) === null || _this$_featureServer16 === void 0 ? void 0 : _this$_featureServer16.objectIdField;
  }

  // Add properties/columns to outFields if they are needed for styling. Otherwise, these properties won't be in tile features
  get outFields() {
    var _this$_item$activeTab, _this$_item$activeTab2;
    return Array.from(new Set([this._item.objectIdField, this._item.activeTableStyle.tableColorMap.colorTraits.colorColumn, (_this$_item$activeTab = this._item.activeTableStyle.outlineStyleMap.traits) === null || _this$_item$activeTab === void 0 ? void 0 : _this$_item$activeTab.column, (_this$_item$activeTab2 = this._item.activeTableStyle.pointStyleMap.traits) === null || _this$_item$activeTab2 === void 0 ? void 0 : _this$_item$activeTab2.column])).filter(t => !!t);
  }
}, _defineProperty(_ArcGisFeatureServerStratum, "stratumName", "featureServer"), _ArcGisFeatureServerStratum), _applyDecoratedDescriptor(_class.prototype, "shortReport", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxScaleDenominator", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxScaleDenominator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minScaleDenominator", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "minScaleDenominator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataCustodian", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataCustodian"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rectangle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rectangle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supportsPagination", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "supportsPagination"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "styles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "styles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "columns", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "columns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tileRequests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tileRequests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "outFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "outFields"), _class.prototype), _class);
function buildMetadataUrl(catalogItem, token) {
  const url = new URI(catalogItem.url).addQuery("f", "json");
  if (token) {
    url.addQuery("token", token);
  }
  return proxyCatalogItemUrl(catalogItem, url.toString());
}
StratumOrder.addLoadStratum(ArcGisFeatureServerStratum.stratumName);